import CreateWindow from "../puzzleWindow";
import { html, render } from "lit-html";
import "./index.css";
import { tips } from "~/src/tips";
import { computerScreens } from "~src/helpers/computerScreens";
import { userChoiceTracker } from "../../helpers/userChoiceTracker"
import { exitButtonPosition} from "../../helpers/exitButtonPosition"
import { iOSallowScroll } from "../../helpers/iOSHacks";
import { textContents } from "../../textcontents";
import { unsafeHTML } from "lit-html/directives/unsafe-html";
const FlatPuzzle = function () {
let answers = [];
let imagesSelected = 0;
let answersStore = {}
let renderFunction = () => null
let modalVisible = true;
let countSelected = () => Object.values(answersStore).filter(function (e) {return e != null}).length
  if(!computerScreens.warehouse.availableToUse()) return;
  const puzzleCode = "warehousePuzzle1" // This is ID relevant to userChoiceTracker
  const markup = () => html`
    <div class="framegram-container">
      <div id="parentInstaWrapper">
        <div id="instaNavi">
          <div class="vasen">
            <div class="logo">
              <img src="${window.pakopeliPublicAssetUrl}img/instagram/framgegram_logo.png" />
            </div>
          </div>
        </div>
        ${modalVisible
          ? html`<div id="instaModal" class="modal">
              <div class="window">
                <div class="modalteksti">
              ${unsafeHTML(textContents.framegram.message)}
                </div>
                <div @click=${() => {
                  
                  window.scene.getSoundByName("generalComputerSound")?.play();
                  modalVisible = false; renderFunction() }} class="instamodalnappi modalnappi">OK</div>
              </div>
            </div>`
          : null}
              <div class="insta-info ${countSelected() > 3 ? "toomany" : ""}">${textContents.framegram.reported}: ${countSelected()} ${textContents.framegram.kpl} </div>
          <div id="instaContentWrapper">
          <div id="instaContent">
            <div class="instaPost">
              <div class="poster">
                <div class="handle">
                  <div><img src="${window.pakopeliPublicAssetUrl}img/instagram/Profiilikuva04.jpg" /></div>
                  <div class="instaNimi">${textContents.framegram.posts.first.name}</div>
                </div>
                <div class="menu"><img src="${window.pakopeliPublicAssetUrl}img/instagram/menu.jpg" /></div>
              </div>
              <div class="linkkikuva">
                <img src="${window.pakopeliPublicAssetUrl}img/instagram/aito_sali.jpg" />
              </div>
              <div class="instaPostausContainer">
                <div class="instaMeta" data-id="1">
                  <div class="vasen">
                    <i class="sydan"><img src="${window.pakopeliPublicAssetUrl}img/instagram/heart.jpg" /></i>
                    <i class="puhekupla"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bubble.jpg"
                    /></i>
                    <i class="share"><img src="${window.pakopeliPublicAssetUrl}img/instagram/share.jpg" /></i>
                  </div>
                  <div class="oikea">
                    <i class="bookmark"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bookmark.jpg"
                    /></i>
                  </div>
                </div>
                <div>
                  <div class="instaLike">49 ${textContents.framegram.likes}</div>
                  <div class="postaus">
                  ${unsafeHTML(textContents.framegram.posts.first.message)}
                  </div>
                </div>
                <div class="report">
                  <input
                    type="checkbox"
                    id="id7"
                    name="id7"
                    data-fakeornot="aito"
                  />
                  <label for="id7">${textContents.framegram.report}</label>
                </div>
              </div>
            </div>

            <div class="instaPost">
              <div class="poster">
                <div class="handle">
                  <div><img src="${window.pakopeliPublicAssetUrl}img/instagram/Profiilikuva05.jpg" /></div>
                  <div class="instaNimi">${unsafeHTML(textContents.framegram.posts.second.name)}</div>
                </div>
                <div class="menu"><img src="${window.pakopeliPublicAssetUrl}img/instagram/menu.jpg" /></div>
              </div>
              <div class="linkkikuva">
                <img src="${window.pakopeliPublicAssetUrl}img/instagram/feikki_vaaristyma.jpg" />
              </div>
              <div class="instaPostausContainer">
                <div class="instaMeta" data-id="1">
                  <div class="vasen">
                    <i class="sydan"><img src="${window.pakopeliPublicAssetUrl}img/instagram/heart.jpg" /></i>
                    <i class="puhekupla"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bubble.jpg"
                    /></i>
                    <i class="share"><img src="${window.pakopeliPublicAssetUrl}img/instagram/share.jpg" /></i>
                  </div>
                  <div class="oikea">
                    <i class="bookmark"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bookmark.jpg"
                    /></i>
                  </div>
                </div>
                <div>
                  <div class="instaLike">123 ${textContents.framegram.likes}</div>
                  <div class="postaus">
                  ${unsafeHTML(textContents.framegram.posts.second.message)}
                  </div>
                </div>
                <div class="report">
                  <input
                    type="checkbox"
                    id="id2"
                    name="id2"
                    data-fakeornot="feikki"
                  />
                  <label for="id2">${textContents.framegram.report}</label>
                </div>
              </div>
            </div>

            <div class="instaPost">
              <div class="poster">
                <div class="handle">
                  <div><img src="${window.pakopeliPublicAssetUrl}img/instagram/Profiilikuva01.jpg" /></div>
                  <div class="instaNimi">${textContents.framegram.posts.third.name}</div>
                </div>
                <div class="menu"><img src="${window.pakopeliPublicAssetUrl}img/instagram/menu.jpg" /></div>
              </div>
              <div class="linkkikuva">
                <img src="${window.pakopeliPublicAssetUrl}img/instagram/aito_koira.jpg" />
              </div>
              <div class="instaPostausContainer">
                <div class="instaMeta" data-id="1">
                  <div class="vasen">
                    <i class="sydan"><img src="${window.pakopeliPublicAssetUrl}img/instagram/heart.jpg" /></i>
                    <i class="puhekupla"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bubble.jpg"
                    /></i>
                    <i class="share"><img src="${window.pakopeliPublicAssetUrl}img/instagram/share.jpg" /></i>
                  </div>
                  <div class="oikea">
                    <i class="bookmark"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bookmark.jpg"
                    /></i>
                  </div>
                </div>
                <div>
                  <div class="instaLike">61 ${textContents.framegram.likes}</div>
                  <div class="postaus">
                  ${unsafeHTML(textContents.framegram.posts.third.message)}
                  </div>
                </div>
                <div class="report">
                  <input
                    type="checkbox"
                    id="id1"
                    name="id1"
                    data-fakeornot="aito"
                  />
                  <label for="id1">${textContents.framegram.report}</label>
                </div>
              </div>
            </div>

            <div class="instaPost">
              <div class="poster">
                <div class="handle">
                  <div><img src="${window.pakopeliPublicAssetUrl}img/instagram/Profiilikuva03.jpg" /></div>
                  <div class="instaNimi">${textContents.framegram.posts.fourth.name}</div>
                </div>
                <div class="menu"><img src="${window.pakopeliPublicAssetUrl}img/instagram/menu.jpg" /></div>
              </div>
              <div class="linkkikuva">
                <img src="${window.pakopeliPublicAssetUrl}img/instagram/feikki_varjo2.jpg" />
              </div>
              <div class="instaPostausContainer">
                <div class="instaMeta" data-id="1">
                  <div class="vasen">
                    <i class="sydan"><img src="${window.pakopeliPublicAssetUrl}img/instagram/heart.jpg" /></i>
                    <i class="puhekupla"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bubble.jpg"
                    /></i>
                    <i class="share"><img src="${window.pakopeliPublicAssetUrl}img/instagram/share.jpg" /></i>
                  </div>
                  <div class="oikea">
                    <i class="bookmark"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bookmark.jpg"
                    /></i>
                  </div>
                </div>
                <div>
                  <div class="instaLike">562 ${textContents.framegram.likes}</div>
                  <div class="postaus">
                  ${unsafeHTML(textContents.framegram.posts.fourth.message)}
                  </div>
                </div>
                <div class="report">
                  <input
                    type="checkbox"
                    id="id3"
                    name="id3"
                    data-fakeornot="feikki"
                  />
                  <label for="id3">${textContents.framegram.report}</label>
                </div>
              </div>
            </div>

            <div class="instaPost">
              <div class="poster">
                <div class="handle">
                  <div><img src="${window.pakopeliPublicAssetUrl}img/instagram/profiilikuva11.jpg" /></div>
                  <div class="instaNimi">${textContents.framegram.posts.fifth.name}</div>
                </div>
                <div class="menu"><img src="${window.pakopeliPublicAssetUrl}img/instagram/menu.jpg" /></div>
              </div>
              <div class="linkkikuva">
                <img src="${window.pakopeliPublicAssetUrl}img/instagram/aito_levykauppa.jpg" />
              </div>
              <div class="instaPostausContainer">
                <div class="instaMeta" data-id="1">
                  <div class="vasen">
                    <i class="sydan"><img src="${window.pakopeliPublicAssetUrl}img/instagram/heart.jpg" /></i>
                    <i class="puhekupla"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bubble.jpg"
                    /></i>
                    <i class="share"><img src="${window.pakopeliPublicAssetUrl}img/instagram/share.jpg" /></i>
                  </div>
                  <div class="oikea">
                    <i class="bookmark"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bookmark.jpg"
                    /></i>
                  </div>
                </div>
                <div>
                  <div class="instaLike">371 ${textContents.framegram.likes}</div>
                  <div class="postaus">
                  ${unsafeHTML(textContents.framegram.posts.fifth.message)}
                  </div>
                </div>
                <div class="report">
                  <input
                    type="checkbox"
                    id="id4"
                    name="id4"
                    data-fakeornot="aito"
                  />
                  <label for="id4">${textContents.framegram.report}</label>
                </div>
              </div>
            </div>

            <div class="instaPost">
              <div class="poster">
                <div class="handle">
                  <div><img src="${window.pakopeliPublicAssetUrl}img/instagram/profiilikuva12.jpg" /></div>
                  <div class="instaNimi">${textContents.framegram.posts.sixth.name}</div>
                </div>
                <div class="menu"><img src="${window.pakopeliPublicAssetUrl}img/instagram/menu.jpg" /></div>
              </div>
              <div class="linkkikuva">
                <img src="${window.pakopeliPublicAssetUrl}img/instagram/feikki_monistus.jpg" />
              </div>
              <div class="instaPostausContainer">
                <div class="instaMeta" data-id="1">
                  <div class="vasen">
                    <i class="sydan"><img src="${window.pakopeliPublicAssetUrl}img/instagram/heart.jpg" /></i>
                    <i class="puhekupla"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bubble.jpg"
                    /></i>
                    <i class="share"><img src="${window.pakopeliPublicAssetUrl}img/instagram/share.jpg" /></i>
                  </div>
                  <div class="oikea">
                    <i class="bookmark"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bookmark.jpg"
                    /></i>
                  </div>
                </div>
                <div>
                  <div class="instaLike">198 ${textContents.framegram.likes}</div>
                  <div class="postaus">
                  ${unsafeHTML(textContents.framegram.posts.sixth.message)}
                  </div>
                </div>
                <div class="report">
                  <input
                    type="checkbox"
                    id="id5"
                    name="id5"
                    data-fakeornot="feikki"
                  />
                  <label for="id5">${textContents.framegram.report}</label>
                </div>
              </div>
            </div>

            <div class="instaPost">
              <div class="poster">
                <div class="handle">
                  <div><img src="${window.pakopeliPublicAssetUrl}img/instagram/profiilikuva13.jpg" /></div>
                  <div class="instaNimi">${textContents.framegram.posts.seventh.name}</div>
                </div>
                <div class="menu"><img src="${window.pakopeliPublicAssetUrl}img/instagram/menu.jpg" /></div>
              </div>
              <div class="linkkikuva">
                <img src="${window.pakopeliPublicAssetUrl}img/instagram/aito_pose.jpg" />
              </div>
              <div class="instaPostausContainer">
                <div class="instaMeta" data-id="1">
                  <div class="vasen">
                    <i class="sydan"><img src="${window.pakopeliPublicAssetUrl}img/instagram/heart.jpg" /></i>
                    <i class="puhekupla"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bubble.jpg"
                    /></i>
                    <i class="share"><img src="${window.pakopeliPublicAssetUrl}img/instagram/share.jpg" /></i>
                  </div>
                  <div class="oikea">
                    <i class="bookmark"
                      ><img src="${window.pakopeliPublicAssetUrl}img/instagram/bookmark.jpg"
                    /></i>
                  </div>
                </div>
                <div>
                  <div class="instaLike">644 ${textContents.framegram.likes}</div>
                  <div class="postaus">
                  ${unsafeHTML(textContents.framegram.posts.seventh.message)}
                  </div>
                </div>
                <div class="report">
                  <input
                    type="checkbox"
                    id="id6"
                    name="id6"
                    data-fakeornot="aito"
                  />
                  <label for="id6">${textContents.framegram.report}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  const puzzleWindowData = CreateWindow({
    removeContainer: true,
    exitCallback: () => {
      if(!userChoiceTracker.retrieve()[puzzleCode]) {
          if(answers.length === 0) {
        tips.solveWarehouseComputer.setTime(5, {override: true})
          } else {
            tips.warehouseComputerWrong.setTime(1, {override: true})
          }
    } else {

    }
  },
  });
  const puzzleWindow = puzzleWindowData.element;
  const exit = puzzleWindowData.exit;

  render(markup(), puzzleWindow);

  const container = document.getElementsByClassName("framegram-container")[0];
  const inputs = container.querySelectorAll("input");

  const isCorrectAnswer = () => {
    const stored = Object.values(answersStore)
    const correctAnswer = countSelected() === 3 && stored.filter(e => e === "feikki").length == 3;
   
    if (correctAnswer) {
      userChoiceTracker.processAnswer(puzzleCode, true); // correct answer stored
      exit();
      tips.flatComputer.setTime(90)
      tips.solveWarehouseComputer.clear()
      tips.warehouseComputerWrong.clear()
      computerScreens.warehouse.lock();
      computerScreens.flat.open();
    } else if (stored.length === 3) {
      tips.warehouseComputerWrong.setTime(15)
    }
    return correctAnswer;
  };

  for (let index = 0; index < inputs.length; index++) {
    inputs[index].onchange = (e) => {
      window.scene.getSoundByName("generalComputerSound")?.play();
      if (e.target.checked) {
        answersStore[e.target.id] = e.target.dataset.fakeornot,
        render(markup(), puzzleWindow);
        isCorrectAnswer();
      } else {
        const index = answers.findIndex((item) => item.id === e.target.id);
        // [1,3,4,5,6]
        // 3

        // delete id from answers
        answersStore[e.target.id] = null;
        isCorrectAnswer();
        render(markup(), puzzleWindow);
      }
    };
  }

  renderFunction = () => render(markup(), puzzleWindow);

  const scroller = iOSallowScroll("#parentInstaWrapper")
  
  exitButtonPosition();
};

export default FlatPuzzle;
